export * from './app-header.component';



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/components/app-header/index.ts